// @flow

import addEstimateItem from '../../../Services/addEstimateItem';
import type { AddEstimateItemParams } from '../../../types';

export default (params: AddEstimateItemParams) => async (dispatch: Function) => dispatch(addEstimateItem(params))